import type { ReactNode } from 'react';
import classNames from 'styles/utils/classNames';

interface Props {
  label: string;
  children: ReactNode;
  className?: string;
  /** Control beside the heading (e.g. "Learn more"). */
  action?: ReactNode;
  /** Sit the action right after the label instead of at the far end. */
  actionInline?: boolean;
}

/** A labelled filter block: a bold section heading + its chips/field, separated
 *  from the previous block by a hairline divider (the first block has none). */
export default function FilterSection({
  label,
  children,
  className,
  action,
  actionInline = false,
}: Props) {
  return (
    <section
      className={classNames(
        'flex flex-col gap-ds-md border-t border-color-border-input-lightmode py-ds-xl first:border-t-0 first:pt-0 dark:border-color-border-input-darkmode',
        className,
      )}
    >
      <div
        className={classNames(
          'relative z-[1] flex items-center',
          actionInline ? 'gap-ds-xl' : 'justify-between gap-ds-md',
        )}
      >
        <h3 className="typography-product-subheading text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {label}
        </h3>
        {action}
      </div>
      {children}
    </section>
  );
}
